import { render, staticRenderFns } from "./addDailyVisit.vue?vue&type=template&id=0167a465&"
import script from "./addDailyVisit.vue?vue&type=script&lang=js&"
export * from "./addDailyVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports